<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						角色經驗所需表
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<h3 class="item-title">
					經驗藥水
				</h3>
				<table class="table table-bordered">
					<tr>
						<td width="20%" align="center">
							小型 EXP 藥水
							<img width="80px" class="d-block mx-auto" src="/static/images/item/icon_item_20001.png" alt="60xp">
							使用後增加角色60的EXP。
						</td>
						<td width="20%" align="center">
							普通 EXP 藥水
							<img width="80px" class="d-block mx-auto" src="/static/images/item/icon_item_20002.png" alt="300xp">
							使用後增加角色300的EXP。
						</td>
						<td width="20%" align="center">
							高劑量 EXP 藥水
							<img width="80px" class="d-block mx-auto" src="/static/images/item/icon_item_20003.png" alt="1500xp">
							使用後增加角色1500的EXP。
						</td>
						<td width="20%" align="center">
							特級 EXP 藥水
							<img width="80px" class="d-block mx-auto" src="/static/images/item/icon_item_20004.png" alt="7500xp">
							使用後增加角色7500的EXP。
						</td>
						<td width="20%" align="center">
							究極 EXP 藥水
							<img width="80px" class="d-block mx-auto" src="/static/images/item/icon_item_20005.png" alt="7500xp">
							使用後增加角色37500的EXP。
						</td>
					</tr>
				</table>
				<h3 class="item-title">
					角色經驗值所需
				</h3>
				<table class="table table-bordered">
					<tr>
						<th width="33%">Lv</th>
						<th width="33%">經驗值</th>
						<th width="33%">合計</th>
					</tr>
					<tr v-for="(item,index) in allExp">
						<td>{{index}}→{{Number(item.unit_level)}}</td>
						<td>
							{{item.now_exp}}
							<span class="exp-bottle">
								<img width="30" src="/static/images/item/icon_item_20004.png" alt="7500xp"> x {{Math.ceil(Number(item.now_exp)/7500)}}
							</span>
						</td>
						<td>
							{{item.total_exp}}
							<span class="exp-bottle">
								<img width="30" src="/static/images/item/icon_item_20004.png" alt="7500xp"> x {{Math.ceil(Number(item.total_exp)/7500)}}
							</span>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import experience_unit from '../../assets/edata/experience_unit.txt'
export default {
	name: 'Exp',
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '經驗所需表',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: "超異域公主連結☆Re:Dive 的女神的經驗所需表" }
		]
	},
	data() {
		return {
			exp: {},
		}
	},
	created: function() {
		var self = this;
		var experienceUnit = JSON.parse(self.atou(experience_unit));
		var exp = experienceUnit;
		var getNowExp = _.forEach(exp, function(o, i) {
			if (i == 0) {
				o["now_exp"] = 0;
				return;
			}
			var nowExp = Number(o.total_exp) - Number(exp[Number(i) - 1]["total_exp"]);
			o["now_exp"] = nowExp;
		});
		self.exp = getNowExp;
	},
	computed: {
		allExp() {
			return this.exp;
		}
	},
	mounted: function() {


	}
}

</script>
<style scoped>
</style>
